type NullableDateLike = string | Date | null | undefined;

export type IDateRangeIso = [string | null, string | null];

const toIsoOrNull = (value: NullableDateLike): string | null => {
  if (value == null) return null;

  // Date instance
  if (value instanceof Date) {
    const t = value.getTime();
    return Number.isFinite(t) ? value.toISOString() : null;
  }

  // String
  if (typeof value === "string") {
    const s = value.trim();
    if (s === "") return null;

    // If it's exactly YYYY-MM-DD, build UTC midnight explicitly (stable)
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    if (m) {
      const year = Number(m[1]);
      const month = Number(m[2]); // 1-12
      const day = Number(m[3]);   // 1-31
      const d = new Date(Date.UTC(year, month - 1, day));
      return Number.isFinite(d.getTime()) ? d.toISOString() : null;
    }

    // Otherwise, try parse as date/time string
    const d = new Date(s);
    return Number.isFinite(d.getTime()) ? d.toISOString() : null;
  }

  // Unknown type
  return null;
};

export const toIsoRangeOrNull = (range: unknown): IDateRangeIso => {
  // Expect [a, b] but be defensive
  if (!Array.isArray(range)) return [null, null];

  const from = toIsoOrNull(range[0] as NullableDateLike);
  const to = toIsoOrNull(range[1] as NullableDateLike);

  return [from, to];
};